import { render, staticRenderFns } from "./MenuIcon2.vue?vue&type=template&id=77537891&scoped=true&"
var script = {}
import style0 from "./MenuIcon2.vue?vue&type=style&index=0&id=77537891&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77537891",
  null
  
)

export default component.exports